module.exports = __webpack_public_path__ + "img/play_btn.e6dfbaf.png";